import createIcon from '../../createIcon';

/**
 * @component @name SurroundSound
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjZDMjIgNC45IDIxLjEgNCAyMCA0Wk03Ljc2IDE2LjI0TDYuMzUgMTcuNjVDNC43OCAxNi4xIDQgMTQuMDUgNCAxMkM0IDkuOTUgNC43OCA3LjkgNi4zNCA2LjM0TDcuNzUgNy43NUM2LjU5IDguOTMgNiAxMC40NiA2IDEyQzYgMTMuNTQgNi41OSAxNS4wNyA3Ljc2IDE2LjI0Wk0xMiAxNkM5Ljc5IDE2IDggMTQuMjEgOCAxMkM4IDkuNzkgOS43OSA4IDEyIDhDMTQuMjEgOCAxNiA5Ljc5IDE2IDEyQzE2IDE0LjIxIDE0LjIxIDE2IDEyIDE2Wk0xNy42NiAxNy42NkwxNi4yNSAxNi4yNUMxNy40MSAxNS4wNyAxOCAxMy41NCAxOCAxMkMxOCAxMC40NiAxNy40MSA4LjkzIDE2LjI0IDcuNzZMMTcuNjUgNi4zNUMxOS4yMiA3LjkgMjAgOS45NSAyMCAxMkMyMCAxNC4wNSAxOS4yMiAxNi4xIDE3LjY2IDE3LjY2Wk0xMiAxMEMxMC45IDEwIDEwIDEwLjkgMTAgMTJDMTAgMTMuMSAxMC45IDE0IDEyIDE0QzEzLjEgMTQgMTQgMTMuMSAxNCAxMkMxNCAxMC45IDEzLjEgMTAgMTIgMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SurroundSound = createIcon('SurroundSound', [
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM7.76 16.24L6.35 17.65C4.78 16.1 4 14.05 4 12C4 9.95 4.78 7.9 6.34 6.34L7.75 7.75C6.59 8.93 6 10.46 6 12C6 13.54 6.59 15.07 7.76 16.24ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16ZM17.66 17.66L16.25 16.25C17.41 15.07 18 13.54 18 12C18 10.46 17.41 8.93 16.24 7.76L17.65 6.35C19.22 7.9 20 9.95 20 12C20 14.05 19.22 16.1 17.66 17.66ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z',
      key: '1y0mx5',
    },
  ],
]);

export default SurroundSound;
